import axios from 'axios'
const baseURL = process.env.VUE_APP_API_URL_BASE

const apiRequest = axios.create({
  baseURL,
  headers: {
    ContentType: 'application/json'
  }
})

apiRequest.interceptors.response.use(
  res => {
    return res
  },
  err => {
    return Promise.reject(err)
  }
)

export default apiRequest
